import { useJobContext } from '../contexts/JobContext';

export function useJobs() {
  const context = useJobContext();
  
  if (!context) {
    throw new Error('useJobs must be used within a JobProvider');
  }
  
  return context;
}

export default useJobs;